import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_019.jpg';
page.images = [
  {
    imageId: 'page019_zoom0',
    rectangle: {
      x: 244,
      y: 1907,
      width: 1390,
      height: 558,
    },
    imageSrc: 'images/page019/019 3.jpg',
  },
  {
    imageId: 'page019_zoom1',
    rectangle: {
      x: 600,
      y: 938,
      width: 1185,
      height: 732,
    },
    imageSrc: 'images/page019/019 2.jpg',
  },
  {
    imageId: 'page019_zoom2',
    rectangle: {
      x: 597,
      y: 148 + 150,
      width: 1188,
      height: 743 - 150,
    },
    imageSrc: 'images/page019/019 1.jpg',
  },
];
page.games = [
  {
    id: 'page019_game11',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 927,
    },
    item: {
      id: 'page019_game11',
    },
    rectangle: {
      id: 'page019_rect1',
    },
  },
  {
    id: 'page019_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 343,
    },
    item: {
      id: 'page019_game10',
    },
    rectangle: {
      id: 'page019_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page019_rect0',

    tooltip: '',

    linked: ['page019_game10'],
    x: 138,
    y: 343,
    width: 430,
    height: 357,
  },
  {
    id: 'page019_rect1',

    tooltip: '',

    linked: ['page019_game11'],
    x: 139,
    y: 927,
    width: 429,
    height: 571,
  },
];
export default page;
